import {SortOptionsValues} from "../types/SortOptionsValues";

export const transformSortOptionToStringValue = (sortOption?: SortOptionsValues) => {
    switch (sortOption) {
        case SortOptionsValues.HIGHEST_FLOOR:
            return "-floor";
        case SortOptionsValues.LOWEST_FLOOR:
            return "floor";
        case SortOptionsValues.HIGHEST_PRICE:
            return "-price";
        case SortOptionsValues.LOWEST_PRICE:
            return "price";
        case SortOptionsValues.HIGHEST_ROOMS_NUMBER:
            return "-rooms";
        case SortOptionsValues.LOWEST_ROOMS_NUMBER:
            return "rooms";
        default:
            return null;
    }
};
import {SortOptionsValues} from "../types/SortOptionsValues";

export const transformSortOptionToStringValue = (sortOption?: SortOptionsValues) => {
    switch (sortOption) {
        case SortOptionsValues.HIGHEST_FLOOR:
            return "-floor";
        case SortOptionsValues.LOWEST_FLOOR:
            return "floor";
        case SortOptionsValues.HIGHEST_PRICE:
            return "-price";
        case SortOptionsValues.LOWEST_PRICE:
            return "price";
        case SortOptionsValues.HIGHEST_ROOMS_NUMBER:
            return "-rooms";
        case SortOptionsValues.LOWEST_ROOMS_NUMBER:
            return "rooms";
        default:
            return null;
    }
};
